import customerActions from "../actions";
import commonActions from "../../common/actions";
import queryLoader from "app/graphql/queryLoader";
import messagesActions from "core/state/redux/data/messages/actions";
import queryActions from "core/state/redux/data/queries/actions";
import { apolloClientMutation } from "app/graphql/apolloClient";

export default async (store, action) => {
  try {
    const { data } = await apolloClientMutation.query({
      query: queryLoader("getCustomer"),
      variables: action,
      fetchPolicy: "no-cache",
    });

    if (!data.customer || !data.customer) {
      console.log("GraphQL response", data);
      throw new Error("No customer information retrieved.");
    }

    if (data.customer && action.isLoggedIn === false) {
      store.dispatch(customerActions.setCustomerInformation(data.customer));
      store.dispatch(
        customerActions.getCartInformation(undefined, action.cartToken)
      );
      if (window.location.pathname !== "/register/success") {
        store.dispatch(
          messagesActions.addMessage(
            "You have successfully logged in.",
            "success"
          )
        );
      }

      // store.dispatch(queryActions.removeQuery());
    } else {
      if (action.email !== data.customer.email && action.email !== "") {
        data.customer.email = action.email;
      }
      store.dispatch(
        customerActions.setCustomerInformation(data.customer, action.isLoggedIn)
      );
    }
  } catch (error) {
    console.log(error);
    store.dispatch(messagesActions.addMessage(error.toString(), "danger"));
    store.dispatch(commonActions.unlock());
    store.dispatch(queryActions.removeQuery());
    return;
  }
};
